module.exports = __webpack_public_path__ + "static/elder_oblex-92bb012d94dd1519942488e33af8b5fd.png";